module.exports = __webpack_public_path__ + "media/tr_tr_s1_Ahmet.59582a4a.mp3";